<script setup>
import { ref } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import { useAlert } from "dashboard/composables";
import { useAccount } from "dashboard/composables/useAccount";
import Banner from "dashboard/components/ui/Banner.vue";

const props = defineProps({
  announcement: {
    type: Object,
    required: true,
  },
});

const store = useStore();
const router = useRouter();
const { t } = useI18n();
const { accountScopedRoute } = useAccount();

const isDismissing = ref(false);

const viewDetails = () => {
  router.push(accountScopedRoute("announcements_index"));
};

const dismiss = async () => {
  // Banner.vue no expone un estado disabled/loading para su botón de cierre;
  // este guard evita 2 dispatches si el click llega dos veces antes de resolver.
  if (isDismissing.value) return;
  isDismissing.value = true;
  try {
    await store.dispatch("announcements/dismiss", props.announcement.id);
  } catch {
    useAlert(t("ANNOUNCEMENTS.BANNER.DISMISS_FAILED"));
  } finally {
    isDismissing.value = false;
  }
};
</script>

<template>
  <Banner
    color-scheme="warning"
    :banner-message="announcement.title"
    has-action-button
    :action-button-label="t('ANNOUNCEMENTS.BANNER.VIEW_DETAILS')"
    action-button-icon="i-lucide-arrow-right"
    has-close-button
    @primary-action="viewDetails"
    @close="dismiss"
  />
</template>
